import React from "react";
import { useState } from "react";
import Select from "react-select";
import "./select.css";

const CustomSelect = (props) => {
  const {
    label,
    isRequired,
    validation,
    options,
    onChange = () => {},
    onKeyPress,
    onKeyDown,
    name,
    field,
    className = "",
    handelChange,
    errors,
    ...rest
  } = props;
  // console.log(options, "options");
  return (
    <>
      <div className="form-group select_group mb-3">
        <label>{label}</label>
        {/* <Select onChange={handelChange} options={options} /> */}

        <Select
          {...field}
          options={options}
          value={
            options.find((option) => option?.value === field?.value?.value) ||
            null
          } //  Ensure correct matching
          onChange={(selectedOption) => {
            field.onChange(selectedOption); // Update field value
            onChange(selectedOption); // Call custom onChange if passed
            // if (handelChange) {
            //   handelChange(selectedOption.value); // Call handelChange if provided
            // }
          }}
          {...rest}
        />
        <span style={{ color: "red", fontSize: "14px" }}>
          {errors?.message}
        </span>
      </div>
    </>
  );
};

export default CustomSelect;
